/**
 * Created by lycheng on 2017/10/20.
 */
import 'babel-polyfill'
// 遮罩层的
var layer = {
  open: function (selector) {
    var $selector = selector
    if (typeof selector === 'string') {
      $selector = $(selector)
    }
    $selector.addClass('modal-show').next('.modal-layer').addClass('modal-show')
  },
  close: function (selector) {
    var $selector = selector
    if (typeof selector === 'string') {
      $selector = $(selector)
    }
    $selector.removeClass('modal-show').next('.modal-layer').removeClass('modal-show')
  }
}

export {
  layer
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-layer.js